import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import NumeroEmpruntComponent from '../../../components/Mouvement/Panel/NumeroEmpruntComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';
import LignePanel from './LignePanel';

class NumeroEmpruntPanel extends LignePanel {
	constructor(isMandatory = false) {
		super(isMandatory);
		this.code = CODE_PANEL.NUMERO_EMPRUNT;
		this.icon = { name: 'eur' };
	}

	getLibelle = () => "Numéro d'emprunt";

	isEmpty = (data: Mouvement) => !data?.lignes?.find((ligne) => ligne?.emprunt);

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<NumeroEmpruntComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default NumeroEmpruntPanel;
